import React from "react";
import { BackDrop, ButtonClose, ButtonCloseWrapper, ModalContainer, ModalBody } from "common/src/modal/ModalStyle";

export const Modal = ({ children, closeModal, modalType, noClose, backdrop }) => {
  return (
    <>
      <ModalContainer className={"modal " + modalType} role="dialog">
        {!noClose && (
          <ButtonCloseWrapper className={modalType}>
            <ButtonClose type="button" data-dismiss="modal" onClick={closeModal}>
              ×
            </ButtonClose>
          </ButtonCloseWrapper>
        )}
        <ModalBody className={modalType}>{children}</ModalBody>
      </ModalContainer>
      {((modalType !== "fullscreen" && modalType !== "bottom") || backdrop === true) && (
        <BackDrop className={modalType} />
      )}
    </>
  );
};

export default Modal;

export const useModal = (modalName, modalType = "", noClose = false, dispatch, view, backdrop) => {
  const isVisible = visible(modalName, view);
  const RenderModal = ({ children }) => (
    <React.Fragment>
      {isVisible && (
        <Modal
          closeModal={() => toggleModal(dispatch, modalName, "close")}
          modalType={modalType}
          noClose={noClose}
          key={modalName}
          backdrop={backdrop}
        >
          {children}
        </Modal>
      )}
    </React.Fragment>
  );

  return {
    RenderModal,
  };
};

export const visible = (MODAL_NAME, view) => view[MODAL_NAME].visible;

export const toggleModal = (dispatch, name, action) =>
  dispatch({
    type: `${name}_TOGGLE`,
    payload: action !== "close",
    toLog: {
      eventName: `${action} ${name}`,
      elemId: name,
    },
  });
